import Swiper, { Navigation, Pagination } from 'swiper';

const swiper = new Swiper('.recruitment-slider', {
    modules: [Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    navigation: {
        nextEl: '.recruitment-slider-button-next',
        prevEl: '.recruitment-slider-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
    },
    pagination: {
        el: '.recruitment-slider-pagination',
        type: 'custom',
        renderCustom(swiper, current, total) {
            const newCurrent = current < 10 ? `0${current}` : current;
            const newTotal = total < 10 ? `0${total}` : total;
            return `<p><span>${newCurrent}</span>/${newTotal}</p>`;
        },
    },
});
